'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import uuid from 'react-uuid';
import {Checkbox, CheckboxGroup} from 'react-checkbox-group';
import {Dropdown} from '../../../../../components/Dropdown/index';
import {ValidationErrorMessages} from '../../../../../components/forms/ValidationErrorMessages';
import {checkIsItemSelected, getItemKey} from '../utils';


export function ListFieldEditView(props) {
  const options = props.field.options;
  return (
    <Fragment>
      <div
        className={classNames("ListFieldEdit", {
          ListFieldEdit_saving: props.isSaving,
          ListFieldEdit_error: get(props.validationMessages, 'length'),
        })}
      >
        {options.selectMany ? selectMultiple(props) : selectSingle(props)}
      </div>
      <ValidationErrorMessages validationMessages={props.validationMessages} />
    </Fragment>
  );
}

function selectMultiple(props) {
  const newId = uuid();
  return (
    <div className="ListFieldEdit__selectMultiple">
      <CheckboxGroup
        className="ListFieldEdit__checkboxGroup"
        checkboxDepth={3}
        name={`listItems${props.field.id}`}
        value={props.value}
        onChange={props.onMultipleChange}
      >
        {props.options.map(option => (
          <label
            key={option.value}
            className="ListFieldEdit__checkboxLabel"
            htmlFor={newId + option.value}
          >
            <Checkbox
              id={newId + option.value}
              className="ListFieldEdit__checkbox"
              value={option.value}
            />
            {option.label}
            <i className="ListFieldEdit__check" />
          </label>
        ))}
      </CheckboxGroup>
    </div>
  );
}

function selectSingle(props) {
  return (
    <div className="ListFieldEdit__selectSingle">
      <Dropdown
        disabled={props.isSaving}
        options={props.options}
        onChange={props.onSingleChange}
        value={props.value}
        placeholder={props.selectOnePlaceholder}
        checkIsSelected={checkIsItemSelected}
        getKey={getItemKey}
      />
    </div>
  );
}

ListFieldEditView.propTypes = {
  value: T.any,
  options: T.array.isRequired,
  field: T.object.isRequired,
  isSaving: T.bool.isRequired,
  onSingleChange: T.func.isRequired,
  onMultipleChange: T.func.isRequired,
  onChange: T.func.isRequired,
  validationMessages: T.arrayOf(T.string),

  emptyPlaceholder: T.string,
  selectOnePlaceholder: T.string,
};



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/ListFieldEdit/ListFieldEditView.js